(function(){
  document.addEventListener('click', function(e){
    // product gallery thumbnail switch
    var t = e.target.closest('.pg-thumb');
    if(t){ var main=document.getElementById('pg-main-img'); if(main){ main.src = t.getAttribute('data-src'); } return; }

    // mobile menu toggle
    var btn = e.target.closest('[data-nav-toggle]');
    if(btn){
      var header = btn.closest('.site-header');
      var open = header.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    // close the mobile menu after tapping a link inside it
    if(e.target.closest('.main-nav a')){
      var openHeader = document.querySelector('.site-header.is-open');
      if(openHeader){
        openHeader.classList.remove('is-open');
        var tg = openHeader.querySelector('[data-nav-toggle]');
        if(tg){ tg.setAttribute('aria-expanded','false'); }
      }
    }
  });

  // close the mobile menu with the Escape key
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){
      var openHeader = document.querySelector('.site-header.is-open');
      if(openHeader){
        openHeader.classList.remove('is-open');
        var tg = openHeader.querySelector('[data-nav-toggle]');
        if(tg){ tg.setAttribute('aria-expanded','false'); }
      }
    }
  });

  // product page: update price + button when a variant is selected
  var variantSelect = document.querySelector('[data-variant-select]');
  if(variantSelect){
    variantSelect.addEventListener('change', function(){
      var opt = variantSelect.options[variantSelect.selectedIndex];
      var current = document.querySelector('[data-current]');
      var compare = document.querySelector('[data-compare]');
      if(current && opt.dataset.price){ current.textContent = opt.dataset.price; }
      if(compare){ compare.textContent = opt.dataset.compare || ''; }
      var addBtn = document.querySelector('[data-add-btn]');
      if(addBtn){
        var available = opt.dataset.available === 'true';
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'In winkelmand' : 'Uitverkocht';
      }
    });
  }
})();

// ----- Cart drawer (uitschuif-winkelmand) -----
(function(){
  var drawer = document.querySelector('[data-cart-drawer]');
  if(!drawer) return;
  var itemsEl = drawer.querySelector('[data-cart-items]');
  var footEl = drawer.querySelector('[data-cart-footer]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');

  function money(cents, currency){
    try { return (cents/100).toLocaleString('nl-BE', {style:'currency', currency: currency || 'EUR'}); }
    catch(e){ return '€ ' + (cents/100).toFixed(2); }
  }

  function esc(s){ var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function setCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(b){
      b.textContent = n;
      if(n > 0){ b.removeAttribute('hidden'); } else { b.setAttribute('hidden',''); }
    });
  }

  function thumb(url){
    if(!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function render(cart){
    setCount(cart.item_count);
    if(cart.item_count === 0){
      itemsEl.innerHTML = '<p class="cart-empty">Je winkelmand is nog leeg.</p>';
      footEl.setAttribute('hidden','');
      return;
    }
    var html = '';
    cart.items.forEach(function(it){
      var img = it.image ? '<img src="'+ esc(thumb(it.image)) +'" alt="" loading="lazy">' : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title')
        ? '<span class="cd-variant">'+ esc(it.variant_title) +'</span>' : '';
      html += '<div class="cd-item" data-key="'+ esc(it.key) +'">'
        + '<a class="cd-thumb" href="'+ esc(it.url) +'">'+ img +'</a>'
        + '<div class="cd-info">'
        +   '<a class="cd-title" href="'+ esc(it.url) +'">'+ esc(it.product_title) +'</a>'
        +   variant
        +   '<div class="cd-qty">'
        +     '<button type="button" class="cd-minus" data-key="'+ esc(it.key) +'" aria-label="Minder">−</button>'
        +     '<span class="cd-q">'+ it.quantity +'</span>'
        +     '<button type="button" class="cd-plus" data-key="'+ esc(it.key) +'" aria-label="Meer">+</button>'
        +     '<button type="button" class="cd-remove" data-key="'+ esc(it.key) +'">Verwijderen</button>'
        +   '</div>'
        + '</div>'
        + '<div class="cd-price">'+ money(it.final_line_price, cart.currency) +'</div>'
        + '</div>';
    });
    itemsEl.innerHTML = html;
    subtotalEl.textContent = money(cart.items_subtotal_price, cart.currency);
    footEl.removeAttribute('hidden');
  }

  function fetchCart(){ return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }); }

  function open(){ document.body.classList.add('cart-open'); drawer.setAttribute('aria-hidden','false'); fetchCart().then(render); }
  function close(){ document.body.classList.remove('cart-open'); drawer.setAttribute('aria-hidden','true'); }

  function changeQty(key, qty){
    itemsEl.style.opacity = '.5';
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); }).then(function(cart){ itemsEl.style.opacity = ''; render(cart); });
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-cart-open]')){ e.preventDefault(); open(); return; }
    if(e.target.closest('[data-cart-close]')){ close(); return; }
    var ctrl = e.target.closest('.cd-minus, .cd-plus, .cd-remove');
    if(ctrl){
      var key = ctrl.getAttribute('data-key');
      var item = drawer.querySelector('.cd-item[data-key="'+ key +'"]');
      var q = item ? parseInt(item.querySelector('.cd-q').textContent, 10) : 1;
      if(ctrl.classList.contains('cd-remove')){ changeQty(key, 0); }
      else if(ctrl.classList.contains('cd-plus')){ changeQty(key, q + 1); }
      else { changeQty(key, Math.max(0, q - 1)); }
    }
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && document.body.classList.contains('cart-open')){ close(); }
  });

  // add to cart via AJAX, then open the drawer
  var pform = document.querySelector('.product-form');
  if(pform){
    pform.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = pform.querySelector('[data-add-btn]');
      var orig = btn ? btn.textContent : '';
      if(btn){ btn.disabled = true; btn.textContent = 'Toevoegen…'; }
      fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body: new FormData(pform) })
        .then(function(r){ if(!r.ok){ throw new Error('add failed'); } return r.json(); })
        .then(function(){ if(btn){ btn.disabled = false; btn.textContent = orig; } open(); })
        .catch(function(){ pform.submit(); });
    });
  }
})();